import { IonButton, IonModal } from '@ionic/react';
import React from 'react';
import { useIcons } from '../../../hooks/useIcons';
import './ChDialog.scss';

export type ChDialogButtonVariant = 'primary' | 'secondary' | 'danger';

export interface ChDialogButton {
  text: string;
  role?: string;
  variant?: ChDialogButtonVariant;
  handler?: () => void;
}

export interface ChDialogProps {
  isOpen: boolean;
  onDismiss: () => void;
  title?: string;
  message: string;
  buttons: ChDialogButton[];
  showLogo?: boolean;
  backdropDismiss?: boolean;
  className?: string;
}

export const ChDialog: React.FC<ChDialogProps> = ({
  isOpen,
  onDismiss,
  title,
  message,
  buttons,
  showLogo = false,
  backdropDismiss = true,
  className = '',
}) => {
  const { icons } = useIcons();

  const handleButtonClick = (button: ChDialogButton) => {
    button.handler?.();
    onDismiss();
  };

  const modalClassName = ['ch-dialog-modal', className]
    .filter(Boolean)
    .join(' ');
  const actionsClassName =
    buttons.length === 1
      ? 'ch-dialog__actions ch-dialog__actions--single'
      : 'ch-dialog__actions';

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onDismiss}
      className={modalClassName}
      backdropDismiss={backdropDismiss}
    >
      <div className="ch-dialog">
        {showLogo && (
          <div className="ch-dialog__logo">
            <img src={icons.chLogoDarkMode} alt="Crate Hackers" />
          </div>
        )}
        {title && <h2 className="ch-dialog__title">{title}</h2>}
        <p className="ch-dialog__message">{message}</p>
        <div className={actionsClassName}>
          {buttons.map((button, index) => (
            <IonButton
              key={`${button.text}-${index}`}
              fill={
                button.variant === 'primary' || button.variant === 'danger'
                  ? 'solid'
                  : 'clear'
              }
              color={
                button.variant === 'danger'
                  ? 'danger'
                  : button.variant === 'primary'
                    ? 'primary'
                    : 'medium'
              }
              className={`ch-dialog__button ch-dialog__button--${button.variant ?? 'secondary'}`}
              onClick={() => handleButtonClick(button)}
            >
              {button.text}
            </IonButton>
          ))}
        </div>
      </div>
    </IonModal>
  );
};
